import { render, staticRenderFns } from "./VideoBlockLayout.vue?vue&type=template&id=3145d821"
import script from "./VideoBlockLayout.vue?vue&type=script&lang=js"
export * from "./VideoBlockLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports